import { categories } from "@/mocks/categories";

export default function CategoryHub() {
  const handleClick = (url: string) => {
    window.open(url, "_blank", "noopener,nofollow");
  };

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          <div className="lg:w-1/2">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20top%20down%20flat%20lay%20of%20diverse%20lifestyle%20items%20including%20headphones%20watch%20wallet%20and%20sunglasses%20on%20marbled%20cream%20surface%2C%20soft%20window%20light%2C%20editorial%20catalog%20aesthetic%2C%20warm%20cinnamon%20and%20sage%20green%20color%20touches%2C%20organized%20grid%20composition%20with%20generous%20gaps&width=900&height=700&seq=cat-hub-main-v2&orientation=landscape"
                alt="Produkty Kakobuy"
                className="w-full h-80 md:h-96 object-cover object-top"
              />
            </div>
            <div className="flex gap-2 mt-3 flex-wrap">
              <span className="px-3 py-1 rounded-full bg-white/60 backdrop-blur-sm text-foreground-700 text-xs font-medium border border-background-200">Sneakers</span>
              <span className="px-3 py-1 rounded-full bg-white/60 backdrop-blur-sm text-foreground-700 text-xs font-medium border border-background-200">Luxury</span>
              <span className="px-3 py-1 rounded-full bg-white/60 backdrop-blur-sm text-foreground-700 text-xs font-medium border border-background-200">Streetwear</span>
            </div>
          </div>

          <div className="lg:w-1/2">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight">
              Kategorie Produktów
            </h2>
            <p className="text-foreground-600 mt-3 text-sm leading-relaxed max-w-md">
              Przeglądaj nasze kategorie i znajdź dokładnie to, czego szukasz. Każda kategoria zawiera starannie wyselekcjonowane produkty z Kakobuy Spreadsheet.
            </p>

            <div className="mt-8 bg-foreground-950 rounded-2xl p-6">
              <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-500/20 text-accent-400 text-xs font-medium mb-4">
                <i className="ri-flashlight-line"></i>
                <span>Popularne</span>
              </div>
              <h3 className="font-heading text-lg font-semibold text-background-50 mb-3">
                Szybki dostęp do kategorii
              </h3>
              <div className="flex flex-wrap gap-2">
                {categories.map((cat) => (
                  <button
                    key={cat.name}
                    onClick={() => handleClick(cat.url)}
                    className="px-4 py-2 rounded-full border border-foreground-700 text-foreground-300 hover:text-background-50 hover:border-primary-500 hover:bg-primary-500/10 text-xs font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    <i className={`${cat.icon} mr-1.5`}></i>
                    {cat.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}